module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "a02_tp"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "imagesm"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/linr.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title1a"
  }, [_c('b', [_vm._v("TANKS "), _c('br'), _vm._v("IN HELL")])]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_vm._v("A MARINE CORPS"), _c('br'), _vm._v("TANK COMPANY"), _c('br'), _vm._v("ON TARAWA")]), _vm._v(" "), _c('p', {
    staticClass: "imagesmm"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/linr.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "editor"
  }, [_c('i', [_vm._v("Oscar E. Gilbert & Romain Cansiere")])]), _vm._v(" "), _c('p', {
    staticClass: "published"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/casemate1.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f9c5a7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/02_tp.vue
// module id = 66
// module chunks = 0